import Head from 'next/head'
import React, { useContext, useEffect } from 'react'
import { Box, Container, Grid, Typography, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import useLazyState from '../hooks/useLazyState'
import LoadMask from '../lib/react-storefront/LoadMask'
import Image from 'next/image'
import SearchIcon from '@material-ui/icons/Search'
import Paper from '@material-ui/core/Paper'
import Link from 'next/link'
import Button from '@material-ui/core/Button'
import isEmpty from 'lodash/isEmpty'
import CloseIcon from '@material-ui/icons/Close'
import Autocomplete from 'react-google-autocomplete'
import getServerSideAPIProps from '../props/getServerSideAPIProps'
import Shop from '../assets/images/shop.png'
import Order from '../assets/images/order.png'
import Deliver from '../assets/images/deliver.png'

import SessionContext from '../contexts/SessionContext'
const useStyles = makeStyles(theme => ({
  iconColor: {
    color: '#9c9c9c !important',
  },
}))

export default function Index(lazyProps) {
  const [state] = useLazyState(lazyProps)
  const classes = useStyles()
  const [zipcode, setZipcode] = React.useState('')
  const [stores, setStores] = React.useState([])
  const [page, setPage] = React.useState(1)
  const [totalPages, setTotalPages] = React.useState(1)
  const { address, actions, config } = useContext(SessionContext)
  const [formatted_address, SetFormattedAddress] = React.useState('')
  const getStoresByZipcode = async e => {
    let zip = e.target.value
    let page = 1
    setZipcode(zip)
    setPage(page)
    if (zip) {
      if (zip.length > 4) {
        await getStores(zip, null, page)
      } else {
        setTotalPages(state.pageData.storedata.totalPages)
        setStores(state.pageData.storedata.stores)
        setPage(state.pageData.storedata.page)
      }
    } else {
      setTotalPages(state.pageData.storedata.totalPages)
      setStores(state.pageData.storedata.stores)
      setPage(state.pageData.storedata.page)
    }
  }

  const getStoresByAddress = async place => {
    let page = 1
    setPage(page)

    if (place) {
      await getStores(zipcode, place, page)
    } else {
      setTotalPages(state.pageData.storedata.totalPages)
      setStores(state.pageData.storedata.stores)
      setPage(state.pageData.storedata.page)
    }
  }
  const getMoreStores = async () => {
    getStores(zipcode, formatted_address ? address : '', page + 1)
  }
  const getStores = async (zip, place, page) => {
    let headers = {
      'Content-Type': 'application/json',
    }

    let res = await fetch('/api/getstores', {
      method: 'post',
      headers: headers,
      body: JSON.stringify({
        zipcode: zip,
        place: place,
        page: page,
      }),
    })
    let data = await res.json()
    SetFormattedAddress(place && place.formatted_address ? place.formatted_address : '')
    if (page > 1) {
      let newStores = stores.concat(data.stores)
      setTotalPages(data.totalPages)
      setStores(newStores)
      setPage(data.page)
    } else {
      setTotalPages(data.totalPages)
      setStores(data.stores)
      setPage(data.page)
    }
  }
 

  useEffect(() => {
    getStores(zipcode, formatted_address ? address : '', page)
  }, [])

  useEffect(() => {
    if (!isEmpty(address)) {
      getStoresByAddress(address)
    }
  }, [address])

  return (
    <>
      {state.loading ? null : (
        <Head>
          <title>{state.pageData.title}</title>
        </Head>
      )}
      <div>
        {state.loading && state.loading != undefined ? (
          <LoadMask transparent />
        ) : (
          <div className={(classes.main, 'body-section')}>
            {/* <Box className="fxd-btn">Get Free Delivery</Box> */}
            <Box className="bg-verlay">
              <Box
                className="cen-spacing location-sec"              
              >
                <Container maxWidth="lg">
                  <h1 className="head-xlg">SHOP LOCAL FOR ALCOHOL</h1>
                  <h2 className="head-sm">BOTTLEZOO – POWERED BY BOTTLEPOS</h2>

                  <Box className="align-hleper">
                    <SearchIcon className="search-icon"></SearchIcon>
                    <Autocomplete
                      apiKey={config?.firebase_api_key}
                      className="full-width field-style"
                      options={{
                        types: ['address'],
                        fields: [
                          'address_components',
                          'geometry.location',
                          'place_id',
                          'formatted_address',
                        ],
                        componentRestrictions: {
                          country: ['us'],
                        },
                      }}
                      onPlaceSelected={place => {
                        getStoresByAddress(place)
                        if (place && place.hasOwnProperty('geometry')) {
                          actions.setAddress(place)
                          SetFormattedAddress(place.formatted_address)
                        }
                      }}
                      onChange={() => {
                        if (document.getElementsByClassName('pac-target-input')[0].value == '') {
                          SetFormattedAddress('')
                          getStores('', '', page)
                        }
                      }}
                      defaultValue={formatted_address ? formatted_address : ''}
                    />
                    {formatted_address ? (
                      <IconButton
                        className={classes.iconColor + ' close-btn search-place'}
                        onClick={e => {
                          SetFormattedAddress('')
                          localStorage.removeItem('userAddress')
                          document.getElementsByClassName('pac-target-input')[0].value = ''

                          getStores('', '', 1)
                        }}
                      >
                        <CloseIcon></CloseIcon>
                      </IconButton>
                    ) : (
                      ''
                    )}
                    {/* <input onKeyUp={getStoresByZipcode} type="text"  placeholder="Enter Zipcode to find nearby stores"></input> */}
                  </Box>
                </Container>
              </Box>
            </Box>

            {stores.length > 0 ? (
              <Box className="edge-spacing">
                <Container maxWidth="lg">
                  <Grid className="actions store-listing" container spacing={2}>
                    {stores.map((store, index) => (
                      <Grid className="store-blk" key={index} item xs={12} lg={4} md={4}>
                        <Link as={'/store/' + store.slug} href="/store/[storeSlug]">
                          <Paper elevation={3} className="block-spacing h-100">
                            <h2>{store.config.bizname}</h2>
                            <Box className="store-img">
                              <img
                                className="img-control"
                                src={
                                  store.config.bizlogo ? store.config.bizlogo : '/default_store.jpg'
                                }
                                alt="Header-logo"
                                width="1000"
                                height="909"
                              ></img>
                            </Box>
                            <b>
                              {store.config.bizname}, {store.config.bizaddress},{' '}
                              {store.config.bizsuburb}, {store.config.bizstate},{' '}
                              {store.config.bizcountry}, {store.config.bizpostcode}
                            </b>
                            {store.hasOwnProperty('pickup_available') && store.pickup_available && (
                              <Button variant="outlined" color="primary" size="small" className="">
                                Pickup
                              </Button>
                            )}
                            {store.hasOwnProperty('delivery_available') &&
                              store.delivery_available && (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  className=""
                                >
                                  Delivery
                                </Button>
                              )}
                          </Paper>
                        </Link>
                      </Grid>
                    ))}
                  </Grid>
                  {page < totalPages && (
                    <Grid item xs={12}>
                      <Button
                        onClick={getMoreStores}
                        variant="contained"
                        color="primary"
                        //
                        size="large"
                        className={'show_more_stores'}
                      >
                        More
                      </Button>
                    </Grid>
                  )}
                </Container>
              </Box>
            ) : (
              <Box className="edge-spacing">
                <Container maxWidth="lg">
                  <Typography align="center" variant={'h3'}>
                    No Stores Found In Your Area!
                  </Typography>
                </Container>
              </Box>
            )}
            <Box className="blue-bg advt-sec">
              <Grid
                className="actions"
                alignContent="center"
                alignItems="center"
                container
                spacing={2}
              >
                <Grid item xs={12} lg={4} md={4} sm={12}>
                  <Box className="thumb-sec">                 
                    <Image src={Shop} width={69} height={82} alt="Shop"/>
                  </Box>
                  <Box className="desc-blk">
                    <h2>Shop</h2>
                    <Box className="desc">
                      Shop See all the Products available at your local store
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4} md={4} sm={12}>
                  <Box className="thumb-sec">
                    <Image src={Order} width={82} height={84} alt="Order"/>
                  </Box>
                  <Box className="desc-blk">
                    <h2>Order</h2>
                    <Box className="desc">Easily add search & add items to your order</Box>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4} md={4} sm={12}>
                  <Box className="thumb-sec">
                  <Image src={Deliver} width={82} height={85} alt="Deliver"/>
                  </Box>
                  <Box className="desc-blk">
                    <h2>Pickup or Deliver</h2>
                    <Box className="desc">Get your Alcohol delivered or pick up at the store.</Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box className="edge-spacing contact-sec">
              <Container maxWidth="lg">
                <h2>Get Free Listing on BottleZoo.</h2>
                <h3>ADD ECOMMERCE TO YOUR BUSINESS.</h3>
                <Box className="text">
                  Get Local Customers to Shop at your Store for Pickup or Delivery
                </Box>
                <Box>                
                  <Link href="/getlisted" passHref>
                    <Button variant="contained" color="primary" className="dark-blue">
                      More Info
                    </Button>
                  </Link>
                </Box>
              </Container>
            </Box>
          </div>
        )}
      </div>
    </>
  )
}

export const getServerSideProps = getServerSideAPIProps('/')
